import { render, staticRenderFns } from "./Devis.vue?vue&type=template&id=4bb95d40&scoped=true"
import script from "./Devis.vue?vue&type=script&lang=js"
export * from "./Devis.vue?vue&type=script&lang=js"
import style0 from "./Devis.vue?vue&type=style&index=0&id=4bb95d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb95d40",
  null
  
)

export default component.exports